import type { IconProps } from './../../models/icon';

export function PartyIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill={secondaryColor}
          d="M20.3144 22.6286L8.86288 18.36C8.52391 18.2404 8.2205 18.0372 7.98058 17.7695C7.74069 17.5019 7.57198 17.178 7.49002 16.828C7.40806 16.478 7.41549 16.113 7.51161 15.7666C7.60771 15.4201 7.78944 15.1035 8.04002 14.8457L15.2229 7.66288C15.4882 7.41419 15.812 7.23652 16.1643 7.14633C16.5166 7.05615 16.886 7.05637 17.2383 7.14699C17.5904 7.2376 17.914 7.41566 18.1791 7.66466C18.4441 7.91368 18.6419 8.22558 18.7544 8.57145L23.0058 20.0229C23.1238 20.3939 23.1361 20.7905 23.041 21.168C22.9458 21.5455 22.7473 21.8891 22.4675 22.1599C22.1879 22.4306 21.838 22.618 21.4576 22.7008C21.0772 22.7836 20.6812 22.7587 20.3144 22.6286Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M20.3143 22.6286L8.86288 18.36C8.52391 18.2403 8.2205 18.0372 7.98059 17.7696C7.74069 17.5018 7.57199 17.178 7.49003 16.828C7.40807 16.478 7.41549 16.1129 7.51161 15.7665C7.60771 15.4202 7.78943 15.1035 8.04002 14.8457L15.2229 7.66287C15.4882 7.41418 15.812 7.23651 16.1643 7.14632C16.5166 7.05615 16.886 7.05637 17.2381 7.14697C17.5904 7.23759 17.9141 7.41565 18.1791 7.66467C18.4441 7.91369 18.642 8.22558 18.7543 8.57144L23.0057 20.0229C23.1238 20.3938 23.136 20.7905 23.041 21.168C22.9459 21.5455 22.7473 21.889 22.4676 22.1599C22.1878 22.4307 21.8381 22.6181 21.4577 22.7009C21.0773 22.7837 20.6813 22.7587 20.3143 22.6286Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M3.51416 12.2228C4.27541 11.798 5.16689 11.6698 6.01702 11.8628"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M7.42277 7.33716C6.93732 6.60533 6.73613 5.72129 6.85706 4.85144"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M11.3658 1.23425C10.7649 3.07483 10.844 5.06986 11.5886 6.85711"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M1.71408 6.48003C2.18746 6.48003 2.57122 6.09627 2.57122 5.62289C2.57122 5.14951 2.18746 4.76575 1.71408 4.76575C1.24069 4.76575 0.856934 5.14951 0.856934 5.62289C0.856934 6.09627 1.24069 6.48003 1.71408 6.48003Z"
        />
      </g>
    </svg>
  );
}
